import React from 'react';
import { Box, Typography, Container } from '@material-ui/core';
import { Wrench, Clock } from '@phosphor-icons/react';
import { useStyles } from './index.styles';
const logoImage = '../../../public/logo1.png';

const SiteMaintenance: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Container className={classes.container}>
        {/* Logo Section */}
        <Box className={classes.logoSection}>
          <img 
            src={logoImage} 
            alt="Attain Data Suite Logo" 
            className={classes.logoImage}
            onError={(e) => {
              console.error('Failed to load logo:', e);
              // Fallback to text logo if image fails
              e.currentTarget.style.display = 'none';
              const fallbackLogo = e.currentTarget.nextElementSibling;
              if (fallbackLogo) {
                fallbackLogo.style.display = 'flex';
              }
            }}
          />
          <Box className={classes.fallbackLogo} style={{ display: 'none' }}>
            <Typography className={classes.logoText}>A</Typography>
          </Box>
          <Typography className={classes.brandText}>Attain Data Suite</Typography>
        </Box>

        {/* Main Content */}
        <Box className={classes.contentSection}>
          <Box className={classes.iconContainer}>
            <Wrench className={classes.mainIcon} />
          </Box>
          
          <Typography variant="h1" className={classes.title}>
            System Maintenance
          </Typography>
          
          <Typography variant="h2" className={classes.subtitle}>
            We're currently performing maintenance
          </Typography>
          
          <Typography variant="body1" className={classes.message}>
            Our team is working hard to improve your experience. The site will be back online shortly.
          </Typography>

          <Box className={classes.statusContainer}>
            <Box className={classes.statusItem}>
              <Clock className={classes.statusIcon} />
              <Typography className={classes.statusText}>Maintenance in Progress</Typography>
            </Box>
          </Box>
        </Box>

        {/* Footer */}
        <Box className={classes.footerSection}>
          <Typography variant="body2" className={classes.footerText}>
            If you have any urgent questions, please contact support.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default SiteMaintenance;
